import { Card, CardContent, CircularProgress, Typography } from '@mui/material'
import { DocumentIcon, PrimaryTickIcon } from '../../../Assets/Images/svgs'
import Styles from './FeaturingJobStatus.module.scss'
import AssetStateLabel from '../../Labels/AssetStateLabel'
import MUIButton from '../MUI-Button'
import { downloadBulkUpdateCsvReport } from '../../../Helpers/Util'
import { useAppDispatch } from '../../../Store/Hooks'
import { CancelOutlined } from '@mui/icons-material'

interface IFeaturingJobStatus {
  reportPrefix?: string
  jobId: string
  status: string
}

const FeaturingJobStatus = ({ reportPrefix, jobId, status }: IFeaturingJobStatus) => {
  const dispatch = useAppDispatch()

  const displayDetail = (title: string, value: string, isLastItem = false) => {
    return (
      <div className={Styles['job-detail-desc']} style={{ paddingBottom: isLastItem ? 0 : '1rem' }}>
        <Typography color='#4A5565'>{`${title}:`}</Typography>
        {title.toLowerCase() === 'status' ? (
          <AssetStateLabel state={status} />
        ) : (
          <Typography fontWeight={500} color='#0A0A0A'>
            {value}
          </Typography>
        )}
      </div>
    )
  }
  const getStatusIcon = () => {
    if (status.toLowerCase() === 'completed') return <PrimaryTickIcon />
    if (status.toLowerCase() === 'failed')
      return <CancelOutlined style={{ width: '20px', height: '20px', color: '#d4351c' }} />
    return <CircularProgress style={{ width: '16px', height: '16px' }} />
  }

  return (
    <Card
      className={Styles['job-status-card']}
      sx={{
        marginTop: '1.5rem',
        boxShadow: 'none',
        borderRadius: '0.5rem',
        border: '1px solid #E5E7EB',
      }}
    >
      <CardContent>
        <div className={Styles['job-status-header']}>
          <div style={{ marginRight: '0.5rem', height: '19px' }}>{getStatusIcon()}</div>
          <Typography fontWeight={600} color='#000' sx={{}}>
            Bulk Featuring Job
          </Typography>
        </div>
        <div style={{ padding: '0.75rem 1rem' }}>
          {displayDetail('Job ID', jobId)}
          {displayDetail('Status', status, true)}
        </div>
        <div className={Styles['dowload-report-cta']}>
          <MUIButton
            size='large'
            type={'button'}
            label={'Download'}
            variant={'contained'}
            handleClickCB={(event: any) => {
              event.stopPropagation()
              const reportFileName = reportPrefix ? `${reportPrefix}_` : ''
              downloadBulkUpdateCsvReport(
                dispatch,
                `${reportFileName}bulkFeaturingJob_${jobId}`,
                jobId,
                'Report downloaded successfully',
                'TrayRanking',
              )
            }}
            color={'primary'}
            className='w-100'
            startIcon={<DocumentIcon />}
            disabled={status.toLowerCase() !== 'completed'}
          />
        </div>
      </CardContent>
    </Card>
  )
}

export default FeaturingJobStatus
